<nb-card class="resetPassContainer">
    <nb-card-header>
        Cambiar contraseña de: <b>{{datos.username}}</b>
    </nb-card-header>
    <nb-card-body>
        <form #changPassword='ngForm'>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Nueva contraseña</mat-label>
                <input matInput #contraseniaInput [type]="getInputTypePw()" [(ngModel)]="contrasenia" name="contrasenia"
                    autocomplete="new-password">
                <button mat-button matSuffix mat-icon-button aria-label="show" (click)="toggleShowPassword()">
                    <mat-icon>{{getIconPw()}}</mat-icon>
                </button>
            </mat-form-field>
            <mat-form-field class="altaLabel" style="width: 29%; margin-right: 1%;">
                <mat-label>Repetir Contraseña</mat-label>
                <input matInput #REcontraseniaInput [type]="getInputTypeREPw()" [(ngModel)]="REcontrasenia"
                    name="REcontrasenia" autocomplete="new-password">
                <button mat-button matSuffix mat-icon-button aria-label="show" (click)="toggleShowREPassword()">
                    <mat-icon>{{getIconREPw()}}</mat-icon>
                </button>
            </mat-form-field>
        </form>
    </nb-card-body>
    <nb-card-footer class="nuevousuarioCardFooter">
        <button nbButton size="tiny" class="buttontz col-2 float-left margin-right" (click)="cerrarModal()">Cancelar
            <nb-icon nbPrefix icon="close-outline" pack="eva"></nb-icon>
        </button>
        <div *ngIf="passErrors" class="altaUsuarioErrors">
            <span *ngIf="contrasenia.length" class="checkPassword" (mouseover)='showPassTooltip = true'
                (mouseout)='showPassTooltip = false'>Verifica
                la contraseña</span>
            <div *ngIf="showPassTooltip" class="passwordTooltip">
                <h4>La contraseña debe contener: </h4>
                <span [ngClass]="contrasenia.length < 8 ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="contrasenia.length < 8 ? 'reqIconError' : 'reqIconOk'">
                        {{contrasenia.length < 8 ? 'highlight_off' : 'check_circle_outline' }} </mat-icon> Como
                            minimo 8 caracteres
                </span>
                <span [ngClass]="contrasenia.length > 15  ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="contrasenia.length > 15 ? 'reqIconError' : 'reqIconOk'">
                        {{contrasenia.length > 15 ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Como maximo 15 caracteres
                </span>
                <span [ngClass]="contrasenia.length < 8 ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="errorCapitalCase ? 'reqIconError' : 'reqIconOk'">{{errorCapitalCase ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos una mayúscula
                </span>
                <span [ngClass]="errorLowerCase ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="errorLowerCase ? 'reqIconError' : 'reqIconOk'">{{errorLowerCase ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos una minúscula
                </span>
                <span [ngClass]="errorHasNumber ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="errorHasNumber ? 'reqIconError' : 'reqIconOk'">{{errorHasNumber ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Al menos un numero
                </span>
                <span [ngClass]="errorPassNotMatch ? 'textErrors' : 'textErrorsOk'">
                    <mat-icon [ngClass]="errorPassNotMatch ? 'reqIconError' : 'reqIconOk'">{{errorPassNotMatch ?
                        'highlight_off' : 'check_circle_outline'}}
                    </mat-icon> Las contraseñas <span *ngIf="errorPassNotMatch">&nbsp;no&nbsp;</span> coinciden
                </span>
            </div>
        </div>
        <button nbButton size="tiny" style="float: right; margin-top: 5px;" class="buttontz" (click)="saveChangePw()"
            [disabled]='passErrors'>Guardar<nb-icon nbPrefix icon="checkmark-outline" pack="eva"></nb-icon></button>
    </nb-card-footer>
</nb-card>

<ng-template #MSJConfirmaCancelarCHNGPW>
    <nb-card>
        <nb-card-header>
            Confirmación
        </nb-card-header>
        <nb-card-body>
            ¿Está seguro que desea guardar los cambios?
        </nb-card-body>
        <nb-card-footer>
            <nb-card-footer>
                <app-spinner *ngIf="showSpinner"></app-spinner>
                <button nbButton *ngIf="!showSpinner" size="tiny" style="float: right; margin-top: 5px;"
                    class="buttontz" (click)="savePassword()">Sí<nb-icon nbPrefix icon="checkmark-outline" pack="eva">
                    </nb-icon></button>
                <button nbButton *ngIf="!showSpinner" size="tiny" class="buttontz col-2 float-left margin-right"
                    (click)="hideConfirm()">No<nb-icon nbPrefix icon="close-outline" pack="eva"></nb-icon></button>
            </nb-card-footer>
        </nb-card-footer>
    </nb-card>
</ng-template>